module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAARCAYAAAAyhueAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAO5JREFUeNpi/N/FQAqYAMSXgXguXKT0P4YiJhIMFALiQCCeA8TJ+BSSYug7IHYA4qeEDGZiIA3cB2JbJIMTqGEozGCYi+czdDMmUMNQELgDxM5A/ALsYjSDyTUUBG5CXfwaanAsTIIRmKTkgLQoBYZrQcOXGYgTgUlsMcjQaUBOJgN1wF8gNmEBEsuA+AIFBvEAcQsQcwLxdKBLL4AMPQLF5ACQQbuQDMylNKJgBtpADcyiNPZBBm6HGjgL2UByDQUZuBGI7cEFS+n/dEoTP8xAV2hJlUKNbLoOauACXAaCAAuJhq6EZs1EfIoAAgwAD8g56ewVg5AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./public/img/icons/arrow-right-orange.png
// module id = 93
// module chunks = 0